import { motion } from "framer-motion";
import { useLang } from "@/i18n/LanguageContext";

const reveal = {
  hidden: { opacity: 0, y: 40 },
  show: { opacity: 1, y: 0, transition: { duration: 0.9, ease: [0.22, 1, 0.36, 1] } },
};

export const Manifesto = () => {
  const { t } = useLang();
  const chapters = t("manifesto.items");

  return (
    <section id="manifesto" data-testid="manifesto-section" className="py-24 lg:py-40">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <motion.p
          initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} viewport={{ once: true }}
          className="text-xs tracking-[0.3em] uppercase font-bold text-primary mb-16 lg:mb-20">
          {t("manifesto.overline")}
        </motion.p>

        <div className="space-y-20 lg:space-y-28">
          {chapters.map((c, i) => (
            <motion.div
              key={i}
              variants={reveal} initial="hidden" whileInView="show" viewport={{ once: true, margin: "-100px" }}
              className={`grid lg:grid-cols-12 gap-6 lg:gap-12 items-start ${i % 2 ? "lg:pl-32" : ""}`}
            >
              <div className="lg:col-span-2">
                <span className="font-serif text-6xl text-primary/40">0{i + 1}</span>
              </div>
              <h3 className="lg:col-span-6 font-serif text-4xl sm:text-5xl leading-[1.05] tracking-tight text-foreground">
                {c.t}
              </h3>
              <p className="lg:col-span-4 text-base text-muted-foreground leading-relaxed lg:pt-4">
                {c.b}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
